<template>
  <OnboardingLayout
    title="Contract Verification"
    description=""
    @onButtonClick="updateDBData"
    imageDescription="Your uploaded contract is currently been verified by Arnergy Legal department"
    :imageUrl="require('@/assets/img/female-wave.gif')"
    :canContinue="canContinue"
    :loading="showLoading"
  >
    <div class="contract-status">
      <div class="contract">
        <h4>{{ contractStatus }}</h4>
      </div>
    </div>
    <!-- KYC -->
    <div v-show="showKYC">
      <div class="kycUpload-container">
        <div class="kycUpload">
          <div>
            <a-upload
              :action="uploadUrl"
              @change="handleChange"
              :before-upload="beforeUpload"
              @drop="handleDrop"
              accept="application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            >
              <a-button> <a-icon type="upload" /> Click to Upload </a-button>
            </a-upload>
          </div>
        </div>
      </div>
    </div>
  </OnboardingLayout>
</template>

<script>
import OnboardingLayout from "@/components/layouts/onboarding-layout.vue";
import OnboardingService from "@/services/onboarding.js";
import { ONBOARDING_URL } from "@/utils/http-common.js";
import { Button, Icon, Upload } from "ant-design-vue";
import { Form, FormItem } from "element-ui";
import { mapGetters } from "vuex";

export default {
  name: "AwaitingContract",
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!",
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!",
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!",
    },
  },
  components: {
    OnboardingLayout,
    "el-form": Form,
    "el-form-item": FormItem,
    "a-upload": Upload,
    "a-button": Button,
    "a-icon": Icon,
  },
  computed: {
    ...mapGetters(["getUserSession"]),
  },
  data() {
    return {
      uploaded_pdf_url: "",
      canContinue: false,
      showLoading: false,
      showKYC: false,
      contractStatus: "",
      nextPageName: "FinishTab",
      formData: {
        utility_doc: "",
        utility_file: "",
        moi_exp_date: "",
        moi: "",
        moi_file: "",
        customer: localStorage.customerId,
      },
      uploadUrl: `${ONBOARDING_URL}/kycfiles/s3-file-upload`,
    };
  },
  methods: {
    handleChange(info) {
      const status = info.file.status;
      if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (status === "done") {
        this.uploaded_pdf_url = info.file.response.url;
        this.canContinue = true;
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    beforeUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5; // 5MB size limit
      if (!isLt5M) {
        message.error("File size must be smaller than 5MB!");
        return false; // Prevent upload
      }
      return true; // Allow upload
    },
    handleDrop(e) {
      console.log(e);
    },
    async updateDBData() {
      try {
        this.showLoading = true;
        let data = {
          customer: localStorage.customerId,
          contract: this.uploaded_pdf_url,
          status: "pending",
        };

        const HTTP = this.$httpUtils.FASTHTTP;
        const res = await HTTP.post("/kycfiles/admin-update-contract", data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("appUserToken")}`,
          },
        });
        console.log({ res });
        if (res) {
          this.showLoading = false;
          location.reload();
        }
      } catch (error) {
        this.showLoading = false;
        console.error("Error: ", error);
      }
    },
    async init() {
      const HTTP = this.$httpUtils.FASTHTTP;
      const stateId = localStorage.getItem("onboardingStateId");
      let url = `/onboardingstate/state?onboardStateId=${stateId}`;
      this.showLoading = true;
      HTTP.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("appUserToken")}`,
        },
      })
        .then(async (response) => {
          this.showLoading = false;
          let customerName = "Customer";
          if (this.getUserSession !== null) {
            customerName =
              this.getUserSession.firstname +
              " " +
              this.getUserSession.lastname.toUpperCase();
          }
          // If Admin approve KYC
          if (response.data.status == "approved") {
            const onWaitList = await OnboardingService.onWaitList();
            if (onWaitList && onWaitList.status) {
              this.navTo("OnboardIPPWaitlist");
            } else {
              this.navTo(this.nextPageName);
            }
            this.showKYC = false;

            return this.contractStatus;
          }
          //   If KYC status is still pending
          else if (response.data.status == "pending") {
            this.showKYC = false;
            this.contractStatus = `Dear ${customerName}, one of our representative is actively reviewing your contract.`;
            return this.contractStatus;
          }
          //   If Admin Rejects KYC
          else if (response.data.status == "decline") {
            this.showKYC = true;
            this.contractStatus =
              "Unfortunately, your contract has been decline. \n Kindly reupload your contract";
            return this.contractStatus;
          } else {
            this.contractStatus = `Dear ${customerName}, one of our representative is actively reviewing your contract.`;
            return this.contractStatus;
          }
        })
        .catch((error) => {
          this.showLoading = false;
          console.log(error);
        });
    },
    async updateStatus() {
      const HTTP = this.$httpUtils.FASTHTTP;
      const payloadData = {
        stateid: "AwaitingContract",
      };

      HTTP.patch("/onboardingstate/nextstate", payloadData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("appUserToken")}`,
        },
      })
        .then(
          (res) => console.log(res)
          // this.$store.commit("saveOnboardingCustomerState", res.data)
        )
        .catch((error) => console.log({ error }));
    },
  },
  async mounted() {
    await this.init();
    await this.updateStatus();
  },
};
</script>

<style lang="scss" scoped>
h4 {
  color: #727272;
  margin-top: 0px;
  margin-bottom: 32px;
}

.contract-status {
  width: 100%;
  max-width: 527px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onboarding/contract-upload/AwaitingContract.vue